import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum EmailStatusIds {
  DRAFT = 1,
  READY_TO_SEND = 2,
  SENT = 3,
  NEEDS_FOLLOW_UP = 4,
  CLOSED = 5,
  // Mail that arrived (cynque-api-server #1770). Display only: the server
  // refuses it from a client with a 400.
  RECEIVED = 6,
}

/** Every status, for display. A form offers getPickableEmailStatii(). */
export function getEmailStatii(): ISelectItem[] {
  return [
    { id: EmailStatusIds.DRAFT, label: 'Draft' },
    { id: EmailStatusIds.READY_TO_SEND, label: 'Ready to Send' },
    { id: EmailStatusIds.SENT, label: 'Sent' },
    { id: EmailStatusIds.NEEDS_FOLLOW_UP, label: 'Needs Follow Up' },
    { id: EmailStatusIds.CLOSED, label: 'Closed' },
    { id: EmailStatusIds.RECEIVED, label: 'Received' },
  ]
}

/**
 * The statuses a user may give an email.
 *
 * A message (sent or received) may only move to Needs Follow Up or Closed --
 * anything else is a 409, and back to Ready to Send would be a resend -- so for
 * one, those two plus the status it already has, so the field still shows it.
 */
export function getPickableEmailStatii({
  isMessage = false,
  currentStatusId,
}: { isMessage?: boolean; currentStatusId?: number } = {}): ISelectItem[] {
  const forAMessage: number[] = [
    EmailStatusIds.NEEDS_FOLLOW_UP,
    EmailStatusIds.CLOSED,
  ]
  return getEmailStatii().filter((status) =>
    isMessage
      ? forAMessage.includes(status.id as number) ||
        status.id === currentStatusId
      : status.id !== EmailStatusIds.RECEIVED
  )
}

export const getEmailStatusByLabel = getItemByLabelFactory(getEmailStatii)
export const getEmailStatusById = getItemByIdFactory(getEmailStatii)
